export default __webpack_public_path__ + "static/media/download.8b450b75.svg";